import React from "react";

const IconRemove = () => <i className="material-icons v-mid">remove</i>;

export default IconRemove;
